export const HOME_ROUTE_PATH = '/'
export const SALES_PIPELINE_SUFFIX = 'sp'
export const SALES_PIPELINE_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId`
export const LOGIN_ROUTE_PATH = '/login'
export const NOT_FOUND_ROUTE_PATH = '*'
export const NO_BOARDS_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId/no-boards`

export const ACCESS_DENIED_ROUTE_PATH = '/access-denied'

export const CLOCK_IN_ROUTE_PATH = '/clock-in'

export const BOARD_SUFFIX = '/b'
export const LIST_SUFFIX = 'l'
export const REMINDERS_SUFFIX = 'reminders'
export const DASHBOARDS_SUFFIX = 'dashboards'
export const CUSTOM_OBJECT_SUFFIX = 'co'
export const CUSTOM_OBJECT_PATH = `/${CUSTOM_OBJECT_SUFFIX}`

export const ANALYTICS_COPILOT_SUFFIX = 'analytics-copilot'
export const CONTACT_BOARD_PREFIX = '/contact-board'
export const LIST_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}/:boardId/${LIST_SUFFIX}/:listId`
export const BOARD_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}/:boardId`
export const PIPELINE_REMINDERS_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}/${REMINDERS_SUFFIX}`
export const ANALYTICS_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId/analytics`

export const CONTACT_BOARD_PATH = `${CONTACT_BOARD_PREFIX}/:boardId`

export const LEAD_PREFIX = `/lead`

export const DEAL_PREFIX = '/deal'

export const CUSTOM_OBJECT_PREFIX = '/custom-object'
export const APPLICATION_PREFIX = '/application'
export const PIPELINE_ENTITY = 'pe'
export const RECORD_PREFIX = '/r'

export const GENERATE_SCRUTINY_KEY_ROUTE_PATH = '/generate-scrutiny-key'

export const DASHBOARDS_PATH = '/dashboards'
export const DASHBOARDS_IN_PIPELINE_SIDEBAR_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}${DASHBOARDS_PATH}`

export const DASHBOARD_DETAILED_VIEW_ROUTE_PATH = `${DASHBOARDS_PATH}/:dashboardId`
export const DASHBOARD_DETAILED_VIEW_IN_PIPELINE_SIDEBAR_ROUTE_PATH = `${DASHBOARDS_IN_PIPELINE_SIDEBAR_PATH}/:dashboardId`

export const LEAD_DETAILED_VIEW_ROUTE_PATH = `/${PIPELINE_ENTITY}/:pipelineId${LEAD_PREFIX}/:leadId`

export const CUSTOM_OBJECT_DETAILED_VIEW_ROUTE_PATH = `/${PIPELINE_ENTITY}/:pipelineId${CUSTOM_OBJECT_PREFIX}/:customObjectId`

export const APPLICATION_DETAILED_VIEW_ROUTE_PATH = `/${PIPELINE_ENTITY}/:pipelineId${APPLICATION_PREFIX}/:applicationId`

export const DEAL_DETAILED_VIEW_ROUTE_PATH = `/${PIPELINE_ENTITY}/:pipelineId${DEAL_PREFIX}/:dealId`

export const RECORD_DETAILED_VIEW_ROUTE_PATH = `${RECORD_PREFIX}/:recordId`

export const GRAPH_SUFFIX = `/g`

export const DASHBOARD_GRAPH_DETAILED_VIEW_ROUTE_PATH = `${DASHBOARD_DETAILED_VIEW_ROUTE_PATH}/:graphId`
export const PIPELINE_DASHBOARDS_GRAPH_DETAILED_VIEW_ROUTE_PATH = `${DASHBOARD_DETAILED_VIEW_IN_PIPELINE_SIDEBAR_ROUTE_PATH}/:graphId`
export const REMINDERS_PATH = '/reminders'

export const CONTACT_DETAILS_ROUTE_PREFIX = 'contact'
export const CONTACT_DETAILS_ROUTE_PATH = `/${CONTACT_DETAILS_ROUTE_PREFIX}/:contactId`

export const PINNED_PIPELINE_ITEMS_ROUTE_PATH = '/pinned'

export const CALLS_SUFFIX = 'calls'
export const CALLS_ROUTE_PATH = `/${CALLS_SUFFIX}`
export const PIPELINE_CALLS_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}/${CALLS_SUFFIX}`

export const HOME_BOARD_SUFFIX = 'home'
export const HOME_BOARD_ROUTE_PATH = `/${HOME_BOARD_SUFFIX}`
export const PIPELINE_HOME_BOARD_ROUTE_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}/${HOME_BOARD_SUFFIX}`

export const ADVANCED_ANALYTICS_DASHBOARDS_ROUTE_PATH = '/dashboards'

export const ANALYTICS_COPILOT_PATH = '/analytics-copilot'

export const ANALYTICS_COPILOT_IN_PIPELINE_SIDEBAR_PATH = `/${SALES_PIPELINE_SUFFIX}/:pipelineId${BOARD_SUFFIX}${ANALYTICS_COPILOT_PATH}`

// Notifications Route
export const NOTIFICATIONS_ROUTE_PATH = '/notifications'

export const ADMIN_ROUTE_SUFFIX = 'admin'

export const ACTIVITY_LOGS_SUFFIX = 'activity-logs'
export const ACTIVITY_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${ACTIVITY_LOGS_SUFFIX}`

export const ADMIN_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}`

export const ADMIN_DASHBOARD_DETAILED_VIEW_ROUTE_PATH = `${ADMIN_ROUTE_PATH}${DASHBOARDS_PATH}/:dashboardId`

export const PARAMETER_STORE_SUFFIX = 'parameters-store'
export const PARAMETERS_STORE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${PARAMETER_STORE_SUFFIX}`

export const PORTAL_APPLICATION_CONFIG_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/portals/:portalId/applications/:portalApplicationId`

//automation workflows paths start region

export const ALL_AUTOMATION_WORKFLOWS_SUFFIX = 'automation-workflows'

export const ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${ALL_AUTOMATION_WORKFLOWS_SUFFIX}`

export const AUTOMATION_WORKFLOWS_DETAILED_PATH = `${ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH}/:awId`

export const AW_EXECUTION_LOGS_SUFFIX = 'aws-execution-logs'

export const AWS_EXECUTION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${AW_EXECUTION_LOGS_SUFFIX}`

export const AUTOMATION_WORKFLOWS_EXECUTION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${AW_EXECUTION_LOGS_SUFFIX}`

export const AW_EXECUTION_LOG_DETAILED_VIEW_ROUTE_PATH = `${AUTOMATION_WORKFLOWS_EXECUTION_LOGS_ROUTE_PATH}/:awExecLogId`

//automation workflows paths end region

//lead distribution paths start region

export const DISTRIBUTION_RULES_SUFFIX = 'distribution-rules'
export const DISTRIBUTION_RULES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${DISTRIBUTION_RULES_SUFFIX}`

export const RD_EXECUTION_LOGS_SUFFIX = 'rd-execution-logs'
export const RD_EXECUTION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${RD_EXECUTION_LOGS_SUFFIX}`

export const AGENT_ALLOCATION_GROUPS_SUFFIX = 'agent-groups'

export const AGENT_ALLOCATION_GROUPS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${AGENT_ALLOCATION_GROUPS_SUFFIX}`
export const AGENT_GROUP_SUFFIX = `/g`
export const AGENT_GROUP_DETAILED_VIEW_ROUTE_PATH = `${AGENT_ALLOCATION_GROUPS_ROUTE_PATH}${AGENT_GROUP_SUFFIX}/:agentGroupId`

export const RECORD_DISTRIBUTION_RULE_SUFFIX = 'ld'
export const RECORD_DISTRIBUTION_RULE_DETAILED_VIEW_PATH = `${DISTRIBUTION_RULES_ROUTE_PATH}/:recordDistributionId`

//lead distribution paths end region

export const ANALYTICS_BUILDER_ENTITY = 'analytics-builder'
export const ANALYTICS_BUILDER_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${ANALYTICS_BUILDER_ENTITY}`
export const GRAPH_DETAILED_VIEW_ROUTE_PATH = `${ANALYTICS_BUILDER_ROUTE_PATH}${GRAPH_SUFFIX}/:graphId`

export const DOWNLOADS_SUFFIX = 'downloads'
export const DOWNLOADS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${DOWNLOADS_SUFFIX}`

export const RELATIONS_SUFFIX = 'relations'
export const RELATIONS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${RELATIONS_SUFFIX}`

export const PROFILE_SETTINGS_SUFFIX = 'settings'

export const PROFILE_SETTINGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${PROFILE_SETTINGS_SUFFIX}`
//IAM paths start region

export const ROLES_SUFFIX = 'roles'
export const ROLES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${ROLES_SUFFIX}`

export const USERS_SUFFIX = 'users'
export const USERS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${USERS_SUFFIX}`

export const USER_GROUPS_SUFFIX = 'user-groups'
export const USER_GROUPS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${USER_GROUPS_SUFFIX}`

export const EXPORT_USERS_PATH = 'export-users'
export const EXPORT_USERS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${EXPORT_USERS_PATH}`

export const CLOCK_IN_CONFIG_SUFFIX = 'clock-in-out'
export const CLOCK_IN_CONFIG_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${CLOCK_IN_CONFIG_SUFFIX}`

export const UPLOAD_ACTIVITIES_PATH = 'upload-activities'
export const UPLOAD_ACTIVITIES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${UPLOAD_ACTIVITIES_PATH}`

//IAM paths end region

//Pipeline events paths start region

export const PIPELINE_EVENTS_SUFFIX = 'pipeline-events'

export const PIPELINE_EVENTS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${PIPELINE_EVENTS_SUFFIX}`

export const PIPELINE_EVENT_TEMPLATE_ROUTE_PATH = `${PIPELINE_EVENTS_ROUTE_PATH}/:pipelineEventTemplateId`

//Cloud Calling Feature Plugins Routes

export const PLUGINS_SUFFIX = 'integrations'
export const PLUGINS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${PLUGINS_SUFFIX}`
export const PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH = `${PLUGINS_ROUTE_PATH}/:pluginId`

export const KNOWLARITY_PLUGIN_SUFFIX = 'knowlarity'
export const KNOWLARITY_PLUGIN_ACCOUNTS_ROUTE_PATH = `${PLUGINS_ROUTE_PATH}/${KNOWLARITY_PLUGIN_SUFFIX}`
export const KNOWLARITY_PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH = `${KNOWLARITY_PLUGIN_ACCOUNTS_ROUTE_PATH}/:pluginId`

export const WHATSAPP_PLUGIN_SUFFIX = 'whatsapp'
export const WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH = `${PLUGINS_ROUTE_PATH}/${WHATSAPP_PLUGIN_SUFFIX}`

export const WATI_SUFFIX = 'wati'
export const WHATSAPP_WATI_ACCOUNTS_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${WATI_SUFFIX}/:pluginId`
export const GALLABOX_SUFFIX = 'gallabox'
export const WHATSAPP_GALLABOX_ACCOUNTS_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${GALLABOX_SUFFIX}/:pluginId`
export const GUPSHUP_SUFFIX = 'gupshup'
export const WHATSAPP_GUPSHUP_ACCOUNTS_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${GUPSHUP_SUFFIX}/:pluginId`

//NOTE: here ad is account details
export const PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX = 'ad'

export const KNOWLARITY_PLUGIN_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${KNOWLARITY_PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH}/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`

//TODO: Need to remove this if not being used
export const PLUGIN_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH}/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`
export const WHATSAPP_WATI_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${WATI_SUFFIX}/:pluginId/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`
export const WHATSAPP_GALLABOX_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${GALLABOX_SUFFIX}/:pluginId/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`
export const WHATSAPP_GUPSHUP_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${WHATSAPP_PLUGIN_ACCOUNTS_ROUTE_PATH}/${GUPSHUP_SUFFIX}/:pluginId/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`

//Pipeline activities paths end region
export const PIPELINE_ACTIVITY_TEMPLATE_PATH = 'activity-templates'

export const PIPELINE_ACTIVITY_TEMPLATES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${PIPELINE_ACTIVITY_TEMPLATE_PATH}`

export const PIPELINE_ACTIVITY_DETAILED_VIEW_ROUTE_PATH = `${PIPELINE_ACTIVITY_TEMPLATES_ROUTE_PATH}/:pipelineActivityTemplateId`

// Stages Route Path
export const PIPELINE_STAGES_PATH = 'stages'

export const PIPELINE_STAGES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${PIPELINE_STAGES_PATH}`
// User Templates
export const USER_PROPERTIES_PATH = 'user-properties'
export const USER_PROPERTIES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${USER_PROPERTIES_PATH}`

// Pipeline settings
export const PIPELINE_SETTINGS_PATH = 'pipeline-settings'
export const OBJECT_PIPELINES_PATH = 'pipelines'

export const PIPELINE_SETTINGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${PIPELINE_SETTINGS_PATH}`

// Sharable Resources
export const SHARABLE_RESOURCES_PATH = 'sharable-resources'
export const SHARABLE_RESOURCES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${SHARABLE_RESOURCES_PATH}`

// Agent Schedules
export const AGENT_SCHEDULES_PATH_SUFFIX = 'agent'

export const AGENT_SCHEDULES_ROUTE_PATH = `/${AGENT_SCHEDULES_PATH_SUFFIX}/:agentId`

// portals
export const PORTALS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/portals`
export const PORTAL_DETAILED_VIEW_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/portals/:portalId`

// Display Stages
export const DISPLAY_STAGES_ROUTE_SUFFIX = `display-stages`

export const DISPLAY_STAGES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${DISPLAY_STAGES_ROUTE_SUFFIX}`

export const GIS_EMBED_URL_PREFIX = `gis-embed-url`

export const GIS_ROUTE_PATH = `/${GIS_EMBED_URL_PREFIX}`

export const APPLICATIONS_ASSIGNED_BY_FRIEND_ROUTE_PATH = '/assigned-by-friend'

//Document Template

export const DOCUMENT_TEMPLATES_ROUTE_SUFFIX = 'document-templates'

export const DOCUMENT_TEMPLATES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}`

export const DOCUMENT_TEMPLATE_DETAILED_VIEW_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}/:documentTemplateVersionId`

//Scoring
export const SCORING_CONFIG_ROUTE_SUFFIX = 'scoring-rules'

export const SCORING_CONFIG_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${SCORING_CONFIG_ROUTE_SUFFIX}`

export const SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX = 'scoring-logs'

export const SCORING_RECALCULATION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX}`

//Smartflo
export const SMARTFLO_ROUTE_SUFFIX = 'smartflo'

export const SMARTFLO_PLUGIN_ACCOUNTS_ROUTE_PATH = `${PLUGINS_ROUTE_PATH}/${SMARTFLO_ROUTE_SUFFIX}`

export const SMARTFLO_PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH = `${SMARTFLO_PLUGIN_ACCOUNTS_ROUTE_PATH}/:pluginId`

export const SMARTFLO_PLUGIN_ACCOUNT_DETAILED_VIEW_ROUTE_PATH = `${SMARTFLO_PLUGIN_ACCOUNT_DETAILS_ROUTE_PATH}/${PLUGIN_ACCOUNT_DETAILED_VIEW_SUFFIX}/:pluginServiceAccountId`

//Admin routes

export const CONTACT_TEMPLATE_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/contact-template`

export const PIPELINE_TASK_TEMPLATES_PATH = 'task-templates'
export const PIPELINE_TASK_TEMPLATES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${PIPELINE_TASK_TEMPLATES_PATH}`
export const PIPELINE_TASK_TEMPLATE_ROUTE_PATH = `${PIPELINE_TASK_TEMPLATES_ROUTE_PATH}/:pipelineTaskTemplateId`

export const TEMPLATE_PATH = 'template'
export const TEMPLATE_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${TEMPLATE_PATH}`

export const RECORD_CREATION_CONFIG_QUERY_PARAM = 'configsView'
export const RECORD_CREATION_CONFIG_PATH = `record-creation-config`
export const RECORD_CREATION_CONFIG_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${TEMPLATE_PATH}/${RECORD_CREATION_CONFIG_PATH}/:recordCreationConfigId`

export const UPLOAD_PIPELINE_ITEMS_PATH = 'upload-pipeline-items'
export const UPLOAD_PIPELINE_ITEMS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/${UPLOAD_PIPELINE_ITEMS_PATH}`

export const UPLOAD_CONTACTS_PATH = 'upload-contacts'
export const UPLOAD_CONTACTS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${UPLOAD_CONTACTS_PATH}`

export const EXPORT_CONTACTS_PATH = 'export-contacts'
export const EXPORT_CONTACTS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${EXPORT_CONTACTS_PATH}`

export const INTEGRATIONS_PATH = 'integrations'
export const INTEGRATIONS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${INTEGRATIONS_PATH}`

export const UPLOAD_USERS_PATH = 'upload-users'
export const UPLOAD_USERS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${UPLOAD_USERS_PATH}`

// Template nested routes
export const TEMPLATES_SUFFIX = 'templates'
export const DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId`

export const ADMIN_PIPELINE_NESTED_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId`

export const ADMIN_TEMPLATES_NESTED_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId`

export const ADMIN_TEMPLATE_PIPELINES_ROUTE_SUFFIX = `pipelines`
export const ADMIN_TEMPLATES_SETTINGS_ROUTE = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${ADMIN_TEMPLATE_PIPELINES_ROUTE_SUFFIX}`

//Boards ROUTES
export const ADMIN_BOARD_ROUTE_SUFFIX = 'boards'
export const ADMIN_TEMPLATE_BOARD_ROUTE_SUFFIX = 'template-boards'

export const TEMPLATES_ADMIN_BOARD_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${ADMIN_BOARD_ROUTE_SUFFIX}`
export const TEMPLATE_ADMIN_TEMPLATE_BOARD_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${ADMIN_TEMPLATE_BOARD_ROUTE_SUFFIX}`

export const PIPELINES_ADMIN_BOARD_ROUTE_PATH = `${ADMIN_PIPELINE_NESTED_ROUTE_PATH}/${ADMIN_BOARD_ROUTE_SUFFIX}`

//template admin automation workflows paths start region

export const OBJECT_ADMIN_ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${ALL_AUTOMATION_WORKFLOWS_SUFFIX}`
export const OBJECT_ADMIN_AUTOMATION_WORKFLOWS_DETAILED_PATH = `${OBJECT_ADMIN_ALL_AUTOMATION_WORKFLOWS_ROUTE_PATH}/${SALES_PIPELINE_SUFFIX}/:pipelineId/:awId`
export const OBJECT_ADMIN_AWS_EXECUTION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${AW_EXECUTION_LOGS_SUFFIX}`
export const OBJECT_ADMIN_AUTOMATION_WORKFLOWS_EXECUTION_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${AW_EXECUTION_LOGS_SUFFIX}`
export const OBJECT_ADMIN_AW_EXECUTION_LOG_DETAILED_VIEW_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${AW_EXECUTION_LOGS_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/:awExecLogId`

//template admin automation workflows paths end region

//lead distribution paths start region

export const OBJECT_ADMIN_DISTRIBUTION_RULES_ROUTE_PATH = `${DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH}/${DISTRIBUTION_RULES_SUFFIX}`
export const OBJECT_ADMIN_RECORD_DISTRIBUTION_RULE_DETAILED_VIEW_PATH = `${DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH}/${DISTRIBUTION_RULES_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId/:recordDistributionId`
export const OBJECT_ADMIN_AGENT_ALLOCATION_GROUPS_ROUTE_PATH = `${DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH}/${AGENT_ALLOCATION_GROUPS_SUFFIX}`
export const OBJECT_ADMIN_AGENT_GROUP_DETAILED_VIEW_ROUTE_PATH = `${DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH}/${AGENT_ALLOCATION_GROUPS_SUFFIX}/${SALES_PIPELINE_SUFFIX}/:pipelineId${AGENT_GROUP_SUFFIX}/:agentGroupId`
export const OBJECT_ADMIN_RD_EXECUTION_LOGS_ROUTE_PATH = `${DISTRIBUTION_RULES_OBJECT_ADMIN_ROUTE_PATH}/${RD_EXECUTION_LOGS_SUFFIX}`

//lead distribution paths end region

export const OBJECT_ADMIN_ACTIVITY_LOGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${ACTIVITY_LOGS_SUFFIX}`
export const OBJECT_ADMIN_PIPELINE_ACTIVITY_TEMPLATES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${PIPELINE_ACTIVITY_TEMPLATE_PATH}`
export const OBJECT_ADMIN_PIPELINE_ACTIVITY_TEMPLATE_DETAILED_VIEW_ROUTE_PATH = `${OBJECT_ADMIN_PIPELINE_ACTIVITY_TEMPLATES_ROUTE_PATH}/:pipelineActivityTemplateId`

export const OBJECT_ADMIN_UPLOAD_PIPELINE_ITEMS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${UPLOAD_PIPELINE_ITEMS_PATH}`
export const OBJECT_ADMIN_UPLOAD_ACTIVITIES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${UPLOAD_ACTIVITIES_PATH}`
export const OBJECT_ADMIN_SHARABLE_RESOURCES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${SHARABLE_RESOURCES_PATH}`

export const OBJECT_ADMIN_DOWNLOADS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${DOWNLOADS_SUFFIX}`
export const OBJECT_ADMIN_RELATIONS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${RELATIONS_SUFFIX}`

export const OBJECT_ADMIN_PIPELINE_SETTINGS_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${OBJECT_PIPELINES_PATH}`

export const OBJECT_ADMIN_DOCUMENT_TEMPLATES_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}`
export const OBJECT_ADMIN_DOCUMENT_TEMPLATE_DETAILED_VIEW_ROUTE_PATH = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${DOCUMENT_TEMPLATES_ROUTE_SUFFIX}/:documentTemplateVersionId`
export const OBJECT_ADMIN_RECORD_TEMPLATE = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId/${TEMPLATE_PATH}`
export const OBJECT_ADMIN_RECORD_CREATION_CONFIG_ROUTE_PATH = `${OBJECT_ADMIN_RECORD_TEMPLATE}/${RECORD_CREATION_CONFIG_PATH}/:recordCreationConfigId`

export const OBJECT_ADMIN_TASK_TEMPLATES_ROUTE_PREFIX = `/${ADMIN_ROUTE_SUFFIX}/${TEMPLATES_SUFFIX}/:templateId`
export const OBJECT_ADMIN_PIPELINE_TASK_TEMPLATES_ROUTE_PATH = `${OBJECT_ADMIN_TASK_TEMPLATES_ROUTE_PREFIX}/${PIPELINE_TASK_TEMPLATES_PATH}`

export const OBJECT_ADMIN_PIPELINE_TASK_TEMPLATE_DETAILED_VIEW_PATH_PREFIX = `${OBJECT_ADMIN_TASK_TEMPLATES_ROUTE_PREFIX}/${PIPELINE_TASK_TEMPLATES_PATH}/${SALES_PIPELINE_SUFFIX}/:pipelineId`
export const OBJECT_ADMIN_PIPELINE_TASK_TEMPLATE_ROUTE_PATH = `${OBJECT_ADMIN_PIPELINE_TASK_TEMPLATE_DETAILED_VIEW_PATH_PREFIX}/:pipelineTaskTemplateId`

export const OBJECT_ADMIN_TEMPLATE_SCORING_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${SCORING_CONFIG_ROUTE_SUFFIX}`
export const OBJECT_ADMIN_SCORING_RULES_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${SCORING_RECALCULATION_LOGS_ROUTE_SUFFIX}`

export const OBJECT_ADMIN_PIPELINE_EVENTS_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${PIPELINE_EVENTS_SUFFIX}`
export const OBJECT_ADMIN_PIPELINE_EVENTS_DETAILED_VIEW_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${PIPELINE_EVENTS_SUFFIX}${SALES_PIPELINE_ROUTE_PATH}/:pipelineEventTemplateId`

export const OBJECT_ADMIN_ANALYTICS_BUILDER_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${ANALYTICS_BUILDER_ENTITY}`
export const OBJECT_ADMIN_GRAPH_DETAILED_VIEW_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${ANALYTICS_BUILDER_ENTITY}/${SALES_PIPELINE_SUFFIX}/:pipelineId${GRAPH_SUFFIX}/:graphId`

// #region - Data Loading
export const DATA_LOADING_SUFFIX = 'data-loading'
export const OBJECT_ADMIN_DATA_LOADING_ROUTE_PATH = `${ADMIN_TEMPLATES_NESTED_ROUTE_PATH}/${DATA_LOADING_SUFFIX}`
export const PIPELINE_ADMIN_DATA_LOADING_ROUTE_PATH = `${ADMIN_PIPELINE_NESTED_ROUTE_PATH}/${DATA_LOADING_SUFFIX}`
// #endregion - Data Loading

// #region - Templates Board

export const TEMPLATES_BOARDS_ROUTE_PATH = `/${TEMPLATES_SUFFIX}/:templateId`
export const TDR_DIGITALIZATION_PREFIX = 'tdr-digitalization'

export const TEMPLATE_BOARD_ROUTE_PATH = `${TEMPLATES_BOARDS_ROUTE_PATH}${BOARD_SUFFIX}/:boardId`
export const TEMPLATE_TDR_DIGITALIZATION_ROUTE_PATH = `/${TDR_DIGITALIZATION_PREFIX}/:templateId`
export const TEMPLATE_TDR_DIGITALIZATION_BOARD_ROUTE_PATH = `${TEMPLATE_TDR_DIGITALIZATION_ROUTE_PATH}${BOARD_SUFFIX}/:boardId`
export const TEMPLATE_BOARD_LIST_ROUTE_PATH = `${TEMPLATE_BOARD_ROUTE_PATH}/${LIST_SUFFIX}/:listId`
// #endregion

//fee -calc
export const FEE_CALCULATOR_ROUTE_PATH = `/fee-calc`

export const PMU_USERS_SUFFIX = 'officers'
export const PMU_USERS_ROUTE_PATH = `/${PMU_USERS_SUFFIX}`
export const PMU_USERS_LOGS_SUFFIX = 'officers-logs'
export const PMU_USERS_LOGS_ROUTE_PATH = `/${PMU_USERS_LOGS_SUFFIX}`
export const NEW_USER_NEW_OFFICER_SUFFIX = 'new-officer'
export const NEW_USER_NEW_OFFICER_ROUTE_PATH = `/${NEW_USER_NEW_OFFICER_SUFFIX}`
export const LTP_USERS_SUFFIX = 'ltp-users'
export const LTP_USERS_ROUTE_PATH = `/${LTP_USERS_SUFFIX}`
export const LTP_USERS_LOGS_SUFFIX = 'ltp-users-logs'
export const LTP_USERS_LOGS_ROUTE_PATH = `/${LTP_USERS_LOGS_SUFFIX}`
export const PMU_APPLICATION_MANAGEMENT_SUFFIX = 'application-management'
export const PMU_APPLICATION_MANAGEMENT_ROUTE_PATH = `/${PMU_APPLICATION_MANAGEMENT_SUFFIX}`
export const PMU_APPLICATION_MANAGEMENT_LOGS_SUFFIX =
   'application-management/logs'
export const PMU_APPLICATION_MANAGEMENT_LOGS_ROUTE_PATH = `/${PMU_APPLICATION_MANAGEMENT_LOGS_SUFFIX}`
export const APPLICATION_MANAGEMENT_PIPELINE_ID_QUERY_PARAM = 'p_id'
export const APPLICATION_MANAGEMENT_PIPELINE_ITEM_ID_QUERY_PARAM = 'pi_id'
export const APPLICATION_MANAGEMENT_PIPELINE_ITEM_TEMPLATE_ID_QUERY_PARAM =
   'pit_id'

export const TDR_MANAGEMENT_SUFFIX = 'tdr-management'
export const TDR_MANAGEMENT_ROUTE_PATH = `/${TDR_MANAGEMENT_SUFFIX}`
export const ON_HOLD_TDR_CERTIFICATE_SUFFIX = 'on-hold-tdr-certificate'
export const ON_HOLD_TDR_CERTIFICATE_ROUTE_PATH = `/${ON_HOLD_TDR_CERTIFICATE_SUFFIX}`
export const CERTIFICATES_LOGS_SUFFIX = 'tdr-certificates-logs'
export const CERTIFICATES_LOGS_ROUTE_PATH = `/${CERTIFICATES_LOGS_SUFFIX}`
export const RELEASE_CERTIFICATE_SUFFIX = 'release-certificate'
export const RELEASE_CERTIFICATE_ROUTE_PATH = `/${RELEASE_CERTIFICATE_SUFFIX}`

export const TASK_SHORTFALL_SUFFIX = 'task-shortfall'
export const TASK_SHORTFALL_ROUTE_PATH = `/${TASK_SHORTFALL_SUFFIX}`
export const APPLICATION_MANAGEMENT_LOGS_SUFFIX = 'application-management-logs'
export const APPLICATION_MANAGEMENT_LOGS_ROUTE_PATH = `/${APPLICATION_MANAGEMENT_LOGS_SUFFIX}`

export const LOG_HIGHLIGHT_QUERY_PARAM = 'highlight'

export const LEGACY_APPLICATIONS_ROUTE_PATH = `/legacy-applications`
export const LEGACY_APPLICATIONS_SUFFIX = `legacy-applications`
export const LEGACY_APPLICATION_DETAILED_VIEW_SUFFIX = `bp_id`

export const TDR_LEGACY_APPLICATIONS_ROUTE_PATH = `/tdr-legacy-applications`

//search-and-monitoring
export const SEARCH_AND_MONITORING_ROUTE_PATH = `/search-and-monitoring`
export const SEARCH_AND_MONITORING_DETAILED_VIEW_ROUTE_PATH = `${SEARCH_AND_MONITORING_ROUTE_PATH}/:applicationId`

export const USER_PROFILE_ROUTE_PATH = `/user-profile`
